module.exports = "<div style=\"background-color: #ccc\">\r\n    <h1>{{title}}</h1>\r\n</div>"